// src/components/dashboard/CVScoreRing.jsx
import { useNavigate } from 'react-router-dom';
import { C } from '../../styles/tokens';

const SCORE      = 73;
const BREAKDOWN  = [
  { label: 'Keywords', value: 82, color: C.magenta },
  { label: 'Format',   value: 90, color: C.violet  },
  { label: 'ATS',      value: 68, color: C.warning },
  { label: 'Impact',   value: 55, color: C.electric },
];

function getScoreLabel(score) {
  if (score >= 85) return { text: 'Excellent', color: C.success };
  if (score >= 70) return { text: 'Needs Work', color: C.warning };
  return { text: 'Poor', color: C.danger };
}

export default function CVScoreRing() {
  const navigate = useNavigate();
  const r          = 38;
  const circumference = 2 * Math.PI * r;
  const offset     = circumference - (SCORE / 100) * circumference;
  const { text, color } = getScoreLabel(SCORE);

  return (
    <div className="card" style={{ padding: '22px' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3 className="syne" style={{ fontSize: '15px', fontWeight: 700 }}>AI CV Score</h3>
        <span style={{ fontSize: '10px', padding: '3px 10px', borderRadius: '100px', background: `${color}15`, color, fontWeight: 700, border: `1px solid ${color}25` }}>
          {text}
        </span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '18px', marginBottom: '18px' }}>
        {/* Ring */}
        <div style={{ position: 'relative', width: '90px', height: '90px', flexShrink: 0 }}>
          <svg width="90" height="90" style={{ transform: 'rotate(-90deg)' }}>
            <defs>
              <linearGradient id="cvGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%"   stopColor={C.magenta} />
                <stop offset="100%" stopColor={C.violet} />
              </linearGradient>
            </defs>
            <circle cx="45" cy="45" r={r} fill="none" stroke="rgba(255,255,255,.06)" strokeWidth="7" />
            <circle cx="45" cy="45" r={r} fill="none" stroke="url(#cvGrad)" strokeWidth="7"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              strokeLinecap="round"
              style={{ transition: 'stroke-dashoffset 1.5s ease' }}
            />
          </svg>
          <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <span className="syne" style={{ fontSize: '20px', fontWeight: 800, color: C.magenta }}>{SCORE}</span>
            <span style={{ fontSize: '9px', color: 'rgba(255,255,255,.35)' }}>/100</span>
          </div>
        </div>

        {/* Breakdown bars */}
        <div style={{ flex: 1 }}>
          {BREAKDOWN.map(b => (
            <div key={b.label} style={{ marginBottom: '8px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
                <span style={{ fontSize: '10px', color: 'rgba(255,255,255,.45)' }}>{b.label}</span>
                <span style={{ fontSize: '10px', fontWeight: 700, color: b.color }}>{b.value}%</span>
              </div>
              <div style={{ height: '3px', borderRadius: '2px', background: 'rgba(255,255,255,.07)' }}>
                <div style={{ height: '100%', width: `${b.value}%`, background: b.color, borderRadius: '2px', transition: 'width 1.2s ease' }} />
              </div>
            </div>
          ))}
        </div>
      </div>

      <button
        onClick={() => navigate('/cv-optimizer')}
        style={{ width: '100%', padding: '11px', background: `linear-gradient(135deg,${C.magenta},${C.violet})`, border: 'none', borderRadius: '9px', color: '#fff', fontSize: '13px', fontWeight: 700, cursor: 'pointer', fontFamily: "'Syne',sans-serif" }}
      >
        🤖 Optimize My CV →
      </button>
    </div>
  );
}
